import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import logo from "../../assets/images/LOGO-BLANC.png";

export default function ButtonAppBar(props) {
  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar
        position="static"
        style={{
          backgroundColor: props.theme.palette.primary.main,
          height: "90px",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Toolbar>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            <img src={logo} style={{ height: "80%", width: "230px" }} />
          </Typography>
          <Typography variant="h6" style={{ color: "white" }}>
            {props.username}
          </Typography>
        </Toolbar>
      </AppBar>
    </Box>
  );
}
